/** First and last name; people saved before the split are read from `name` (first word, then the rest). */
export function personNames(r) {
    if (r.firstName !== undefined || r.lastName !== undefined)
        return { first: (r.firstName || "").trim(), last: (r.lastName || "").trim() };
    const words = r.name.replace(/\(.*?\)/g, " ").trim().split(/\s+/).filter(Boolean);
    return { first: words[0] || r.name.trim(), last: words.slice(1).join(" ") };
}
export function fullName(r) {
    const { first, last } = personNames(r);
    return [first, last].filter(Boolean).join(" ") || r.name;
}
/** The label for a person on the board: their nickname, else the project's chosen first or last name. */
export function displayName(r, config) {
    if (r.nickname?.trim())
        return r.nickname.trim();
    const { first, last } = personNames(r);
    const pick = config?.display?.personName === "last" ? last || first : first || last;
    return pick || r.name;
}
//# sourceMappingURL=people.js.map